module.exports = __webpack_public_path__ + "plus.svg";


//////////////////
// WEBPACK FOOTER
// ./~/ag-grid/src/styles/material-icons/plus.svg?color1=%23333333&color2=
// module id = 2210
// module chunks = 67